import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Announcement from "./Announcement";
import NumberFormat from "react-number-format";
import {
  getDashboardInfo,
  selectDashboardInfo
} from "../../../state/ducks/dashboard/index";

class Dashboard extends Component {
  componentDidMount() {
    this.props.getDashboardInfo();
  }

  render() {
    const { login, dashboardInfo, isCandidateCustomer } = this.props;
    return (
      <>
        <div className="container-fluid">
          {/* Yeşil Alan*/}
          <div className="row t-dashboardyesilAlan">
            <div className="col-12">
              <div className="row no-gutters d-flex justify-content-center pb-4">
                <div className="col-auto pr-4">
                  Son Giriş Tarihi : <strong>{login.info.lastLoginDate}</strong>
                </div>
                <div className="col-auto">
                  Son Giriş IP No : <strong> {login.info.lastIpAddress}</strong>
                </div>
              </div>
            </div>
            {
              !isCandidateCustomer &&
              (
                <div className="col-12 d-flex flex-column align-items-center pb-2" style={{textAlign: "center"}}>
                  <strong className="t-dashboardRakkam" hidden={dashboardInfo.debt?.tutar === 0}>
                    <NumberFormat
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      value={dashboardInfo.debt?.tutar}
                      displayType={"text"}
                    />
                    <span
                      className="card-text"
                      hidden={dashboardInfo.debt?.tutar === 0}
                    >
                      {" "}
                      ₺
                    </span>
                    <span
                      className="text-success"
                      hidden={
                        dashboardInfo.debt?.tutar === 0 ||
                        dashboardInfo.debt?.altin === 0
                      }
                    >
                      {" "}
                      +{" "}
                    </span>
                  </strong>


                  <strong className="t-dashboardRakkam" hidden={dashboardInfo.debt?.altin === 0}>
                    <NumberFormat
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      value={dashboardInfo.debt?.altin}
                      displayType={"text"}
                    /></strong>
                  <h3
                    className="card-text"
                    hidden={dashboardInfo.debt?.altin === 0}
                  >
                    {" "}
                    XAU
                  </h3>


                 {dashboardInfo.anyActiveMember && (
                  <span>
                    <strong style={{ color: "#FFED00" }}>{dashboardInfo.debt?.tarih}
                      <small
                        hidden={
                          dashboardInfo.debt?.tutar === 0 &&
                          dashboardInfo.debt?.altin === 0
                        }
                      >
                        {" "}
                        Ödenecek Toplam Tutar
                      </small>
                      <small
                        hidden={
                          dashboardInfo.debt?.tutar !== 0 ||
                          dashboardInfo.debt?.altin !== 0
                        }
                      >
                        {" "}
                        itibarıyla Ödenecek <br />
                        <strong>Borcunuz Yoktur</strong>
                      </small>
                    </strong>
                  </span>
                         )}

{!dashboardInfo.anyActiveMember && (
                  <span>
                    <strong style={{ color: "#FFED00" }}>
                      
                        Aktif Üyeliğiniz Bulunmamaktadır
                     
                    </strong>
                  </span>
                         )}

                  <Link to="/Home/MemberInfo" className="t-dashboardLink">
                    Detay İçin Tıklayınız
                  </Link>

                </div>
              )
            }

            {/* icon area */}
            <div className="col-12 ">
              <div
                className="row justify-content-center no-gutters"
                // style={{ padding: "20px 5%" }}
              >
                 {/*Ayraç*/}
                {/* <div className="col-auto t-dashboardIconAreaBorderLeft" ></div> */}
                {/*Kolon*/}
                  {dashboardInfo.isShowMemberApplication && (
                <div className="col-5 col-md-5 col-lg-3 t-dashboardiconArea  mt-4 mx-2 ">

                    <Link to="/Home/SmartCalculation">
                      <i className="t-icon-calculator" />
                      <span>
                        Hesaplama
                        <br />
                        Yap
                      </span>
                    </Link>

                </div>
                  )}

                {/*Ayraç*/}
                {/* <div className="col-auto t-dashboardIconAreaBorderLeft" ></div> */}
                {/*Kolon*/}
                {/* <div className="col-5 col-md-5 col-lg-3  mt-4 mx-2 t-dashboardiconArea ">
                  <a href="https://esube.eminevim.com" rel="noopener noreferrer" target="_blank" >
                    <i className="t-icon-photo_camera_front" />
                    <span>
                      Görüntülü
                      <br />
                      Şube
                    </span>
                  </a>
                </div> */}
                {/*Ayraç*/}
                {/* <div className="col-auto d-none d-lg-block t-dashboardIconAreaBorderLeft" ></div> */}
                {/*Kolon*/}
                <div className="col-5 col-md-5 col-lg-3 t-dashboardiconArea mt-4 mx-2 ">


                  <Link
                    to={
                      dashboardInfo?.videoLink?.id !== 0
                        ? "/Home/AnnouncementDetail/" +
                        dashboardInfo?.videoLink?.id
                        : "/Home/Dashboard"
                    }

                  >
                    <i className="t-icon-connected_tv" />
                    <span className="pb-2" id="blink" >Canlı Yayın</span>
                    <div className="t-dashboardCanliYayin" hidden={dashboardInfo?.videoLink?.id !== 0
                    }>
                      Canlı yayınımız yok.
                      {dashboardInfo?.videoLink?.konu}
                    </div>
                    <div  className="t-dashboardCanliYayin" hidden={dashboardInfo?.videoLink?.id === 0
                    } >
                      <strong>Canlı izleyin.</strong> 
                      <br />
                      {dashboardInfo?.videoLink?.konu}
                    </div>

                  </Link>



                </div>
                {/*Ayraç*/}
                {/* <div className="col-auto t-dashboardIconAreaBorderLeft mt-3  d-block d-lg-none" ></div> */}
                {/*Kolon*/}
                <div className="col-5 col-md-5 col-lg-3 t-dashboardiconArea mt-4 mx-2 ">
                  <a href="https://www.eminevim.com/subeler" target="_blank">
                    <i className="t-icon-home pt-3 pt-lg-0" />
                    <span>Şubelerimiz</span>
                  </a>
                </div>
                {/*Ayraç*/}
                {/* <div className="col-auto t-dashboardIconAreaBorderLeft mt-3  d-none d-lg-block" ></div> */}
                {/*Kolon*/}
                <div className="col-5 col-md-5 col-lg-3 t-dashboardiconArea mt-4 mx-2">
                  <a href="https://www.eminevim.com/banka-hesap-numaralarimiz" target="_blank">
                    <i className="t-icon-library" />
                    <span>
                      Banka
                      <br />
                      Bilgilerimiz
                    </span>
                  </a>
                </div>
                {/*Ayraç*/}
                {/* <div className="col-auto t-dashboardIconAreaBorderLeft mt-3" ></div> */}
                {/*Kolon*/}
                <div className="col-5 col-md-5 col-lg-3 t-dashboardiconArea mt-4 mx-2">

                  <Link to="/Home/Questions">
                    <i className="t-icon-question1" />
                    <span>
                      Sıkça Sorulan
                      <br />
                      Sorular
                    </span>

                  </Link>
                </div>
              </div>
            </div>
            {/* Alt Satır*/}
            <div className="col-12 mt-4 mb-4">
              <div className="row no gutters d-flex justify-content-center t-dashboardAltSatir">
                <div className="col-auto md-col px-2 t-dasboardfooter rounded">
                  <i className="t-icon-info_outline pr-2" />

                  <Link to="/Home/AccountInfo">
                    Bilgilerim
                  </Link>
                </div>
                <div className="col-auto md-col px-2 t-dasboardfooter rounded">
                  <i className="t-icon-user-tie pr-2" />

                  <Link to="/Home/AgentInfo" >
                    Temsilci Bilgilerim
                  </Link>
                </div>
                <div className="col-auto md-col px-2 t-dasboardfooter rounded">
                  <i className="t-icon-chat-alt-stroke pr-2" />

                  <Link to="/Home/AskToAgent">
                    Temsilcime Soru Sor
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {/* Duyurlar Baslık*/}

          {/* Duyrular */}

          {
            dashboardInfo?.announcements?.length > 0 &&
            (
              <Announcement
                duyurular={dashboardInfo.announcements}
              ></Announcement>
            )
          }

          {/* duyrular Bitti*/}
          <div className="row" style={{ height: "20px" }}>

          </div>

        </div>
      </>


    );
  }
}

const mapStateToProps = state => {
  return {
    dashboardInfo: selectDashboardInfo(state),
    isCandidateCustomer: state.dashboard.isCandidateCustomer
  };
};

const mapDispatchToProps = dispatch => ({
  getDashboardInfo: () => dispatch(getDashboardInfo())
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
